import type { PricelistCaseFileDTO } from '@erp/rpc';

export function firstCsvDocumentId(
  pricelist: { csvDocuments?: readonly { id: string }[] } | undefined,
): string | undefined {
  return pricelist?.csvDocuments?.[0]?.id;
}

export function resolveSelectedCaseFile(
  files: readonly PricelistCaseFileDTO[],
  selectedDocumentId: string | null,
): PricelistCaseFileDTO | undefined {
  if (files.length === 0) {
    return undefined;
  }
  if (selectedDocumentId !== null) {
    const selected = files.find(
      (file) => file.documentId === selectedDocumentId,
    );
    if (selected !== undefined) {
      return selected;
    }
  }
  return files.find((file) => !file.deprecated) ?? files[0];
}
